import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChangeEvent, useState } from "react";
import styled from "styled-components";

import clearIcon from "../../assets/icons/clear.png";
import { hexToRGB } from "../../utils/style";

/**
 * [共通パーツ]検索型入力欄
 */

type SearchInputProps = {
  clear?: boolean;
  value?: string;
  placeholder?: string;
  onSearch: (value: string) => void;
  onReset: () => void;
  disabled?: boolean;
};

const Container = styled.div`
  display: flex;
  height: 50px;
`;

const InputWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`;

const StyledSearchInput = styled.input`
  background-color: ${(props) => props.theme.colors.primaryBackground};
  color: ${(props) => props.theme.colors.primaryText};
  font-size: ${(props) => props.theme.fontSize.medium};
  ::placeholder {
    opacity: 0.5;
  }
  border: 2px solid ${(props) => hexToRGB(props.theme.colors.brand, 0.4)};
  border-right: none;
  border-radius: 6px 0 0 6px;
  outline: 0;
  width: 100%;
  padding-left: 46px;
`;

const Icon = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

const SearchIcon = styled(Icon)`
  left: 20px;
`;

const CloseIcon = styled(Icon)`
  right: 20px;
  cursor: pointer;
`;

const SearchButton = styled.button<{ disabled: boolean }>`
  width: 100px;
  font-size: 16px;
  background-color: ${(props) =>
    props.disabled
      ? props.theme.colors.disabledBackground
      : props.theme.colors.brand};
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.colors.secondaryText};
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
`;

export function SearchInput({
  value = "",
  clear = true,
  placeholder = "",
  onSearch,
  onReset,
  disabled = false,
}: SearchInputProps) {
  const [searchInputValue, setSearchInputValue] = useState(value || "");

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchInputValue(event.target.value);
  };

  const onClear = () => {
    setSearchInputValue("");
    onReset();
  };

  const searchText = () => {
    onSearch(searchInputValue);
  };

  return (
    <Container>
      <InputWrapper>
        <SearchIcon>
          {<FontAwesomeIcon icon={"search"} color="#10626C" />}
          {/* <img src= width="16" height="16" alt={"search"} /> */}
        </SearchIcon>
        <StyledSearchInput
          type="text"
          value={searchInputValue}
          placeholder={placeholder}
          onChange={handleChange}
        />
        {clear && (
          <CloseIcon onClick={onClear}>
            <img src={clearIcon} width="20" height="20" alt={"clear_text"} />
          </CloseIcon>
        )}
      </InputWrapper>
      <SearchButton
        disabled={!searchInputValue.length || disabled}
        onClick={() => searchText()}
      >
        検索
      </SearchButton>
    </Container>
  );
}
